import { ShieldCheck, Clock, HeartHandshake, Award, Users2, Sparkles } from "lucide-react";

const VALUES = [
  { Icon: ShieldCheck, title: "Safety", desc: "We put safety first on every ride, every time." },
  { Icon: Clock, title: "Reliability", desc: "We value your time and honor every commitment." },
  { Icon: HeartHandshake, title: "Compassion", desc: "We treat every passenger with kindness and respect." },
  { Icon: Award, title: "Professionalism", desc: "Trained, courteous, and prepared for every ride." },
  { Icon: Users2, title: "Respect", desc: "Dignified service that centers the passenger." },
  { Icon: Sparkles, title: "Quality", desc: "Consistent care that reflects our name." },
];

export default function About() {
  return (
    <div className="animate-fade-up">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#1D4ED8] font-semibold mb-3">About Us</div>
          <h1 className="text-4xl sm:text-5xl font-bold text-[#0A192F]">Quality transportation, driven by care</h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Moreno Quality Transportation provides non-emergency medical transportation with a focus on safety, reliability, and compassion. We help patients across Florida reach their medical appointments comfortably and on time.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Our mission is simple: deliver dependable transportation that treats every passenger with dignity, respect, and quality service.
          </p>
        </div>
        <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-lg">
          <img src="https://images.pexels.com/photos/31627609/pexels-photo-31627609.jpeg" alt="Professional driver" className="w-full h-[420px] object-cover" />
        </div>
      </section>

      <section className="bg-slate-50 border-y border-slate-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0A192F]">What we stand for</h2>
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VALUES.map(({ Icon, title, desc }) => (
              <div key={title} className="rounded-2xl bg-white border border-slate-200 p-6 hover:shadow-md transition-shadow">
                <div className="w-11 h-11 rounded-xl bg-blue-50 text-[#1D4ED8] flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-4 text-lg font-semibold text-[#0A192F]">{title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
